import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1280",
  height: "173",
  viewBox: "0 0 1280 173",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon--svg icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M426.81 167.248C252.697 170.364 133.503 163.334 0 141.94V172.044C128.952 172.044 562.68 172.979 1279.96 172.044V0C1009.47 112.173 770.06 150.421 426.81 167.248Z",
      fill: "#004488"
    }, null, -1)
  ])))
}
export default { render: render }